import {useMutation} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type CaracterizacionPreview = components['schemas']['CaracterizacionPreviewRead']
export type CaracterizacionEmpresaData = components['schemas']['CaracterizacionEmpresaData']
export type CaracterizacionPersonaData = components['schemas']['CaracterizacionPersonaData']
export type AdhocCreateResult = components['schemas']['AdhocCreateRead']

/** D-ADHOC step 1: never persists; the admin edits the result before confirming. */
export function usePreviewCaracterizacion() {
  return useMutation({
    mutationFn: async (file: File) => {
      const form = new FormData()
      form.append('file', file)
      return (await api.post<CaracterizacionPreview>('/admin/bateria/adhoc/preview', form)).data
    },
  })
}

/** D-ADHOC step 2: business, roster, evaluación and paquetes in one transaction. */
export function useCreateAdhoc() {
  return useMutation({
    mutationFn: async (input: {
      empresa: CaracterizacionEmpresaData
      personas: CaracterizacionPersonaData[]
      psicologo_user_id: string
      fecha_inicio: string
      /** Las dos salidas del 409 `evaluacion_abierta` (`admin-bateria-adhoc.tsx`). */
      agregar_a_evaluacion_id?: string
      forzar_nueva?: boolean
    }) => (await api.post<AdhocCreateResult>('/admin/bateria/adhoc', input)).data,
  })
}
